import React, { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PaperComponent } from 'shared/ui/draggable/Draggable';
import type { SchedulingRule } from 'repository/schedule/@types/SchedulingRuleModel';
import { useSchedulingRuleForm } from 'hooks/schedulingRules/useSchedulingRuleForm';
import { SchedulingRuleForm } from './SchedulingRuleForm';

interface Props {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: SchedulingRule[];
    selectedRow: SchedulingRule[];
    reloading: () => void;
    mode: 'add' | 'edit';
    cleanSelected: () => void;
}

export const SchedulingRuleDialog: FC<Props> = ({ open, setOpen, rows, selectedRow, reloading, mode, cleanSelected }) => {
    const {
        dialogTitle,
        cancelLabel,
        submitLabel,
        control,
        errors,
        isSubmitting,
        activeStep,
        setActiveStep,
        incompleteWarning,
        setIncompleteWarning,
        shiftProfileGroups,
        loadingShiftProfileGroups,
        handleClose,
        handleFinalSubmit,
    } = useSchedulingRuleForm({
        open,
        setOpen,
        rows,
        selectedRow,
        reloading,
        mode,
        cleanSelected,
    });

    return (
        <Dialog
            open={open}
            onClose={(_, reason) => {
                if (reason !== 'backdropClick') handleClose();
            }}
            PaperComponent={PaperComponent}
            maxWidth="sm"
            fullWidth
            aria-labelledby="draggable-scheduling-rule-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-scheduling-rule-title">
                {dialogTitle}
            </DialogTitle>

            <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}>
                <CloseIcon />
            </IconButton>

            <DialogContent dividers>
                <SchedulingRuleForm
                    mode={mode}
                    control={control}
                    errors={errors}
                    shiftProfileGroups={shiftProfileGroups}
                    loadingShiftProfileGroups={loadingShiftProfileGroups}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    incompleteWarning={incompleteWarning}
                    setIncompleteWarning={setIncompleteWarning}
                />
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>
                    {cancelLabel}
                </Button>
                <Button variant="contained" color="primary" onClick={handleFinalSubmit} disabled={isSubmitting}>
                    {submitLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
